import { getDiscordAuthURL } from "../helperFunctions/getDiscordAuthURL";
import { getTwitchAuthURL } from "../helperFunctions/getTwitchAuthURL";
import { Button, Flex, Text } from "@radix-ui/themes";
import i18next from "i18next";

type CustomSigninProps = {
  logo: string;
  url: string;
  longText: string;
  shortText: string;
  type: string;
};

export const CustomSignInButton: React.FunctionComponent<CustomSigninProps> = ({
  logo,
  url,
  longText,
  shortText,
  type,
}) => {
  const handleCustomButtonEvent = () => {
    localStorage.setItem("signUpMethod", shortText);
    if (type === "discord") {
      return (window.location.href = getDiscordAuthURL());
    }
    if (type === "twitch") {
      return (window.location.href = getTwitchAuthURL());
    }

    window.location.href = url;
  };

  return (
    <Button
      onClick={() => {
        handleCustomButtonEvent();
      }}
      variant="outline"
      style={{ width: "100%" }}
      size="3"
    >
      <Flex gap="2">
        <img src={logo} width={20} height={20} />

        <Text size="2">
          {i18next.t("auth.methods.button")} {longText}
        </Text>
      </Flex>
    </Button>
  );
};
